export default __webpack_public_path__ + "static/media/7.effee24a.jpeg";